export enum MapColors {
  GREEN = '#22ED42',
  LIGHT_GREEN = '#90EE90',
  DARK_GREEN = '#287534',
  YELLOW = '#FFF505',
  DARK_YELLOW = '#eeba25',
  RED = '#EE3524',
  DARK_RED = '#881111',
  GREY = '#C4C4C4',
  BLACK = '#333333',
  BROWN = '#a55129',
  ORANGE = '#ff8e00',
  DARK_ORANGE = '#ff4500',
  PINK = '#ffa0a0',
  LAVENDER = '#ad5bff',
  BLUE = '#00d0ff',
  PURPLE = '#cc00ff',
  DARK = '#000000',
  WHITE = '#ffffff',
  ULTRAMARINE = '#120a8f',
  UNKNOWN = '#333333',
}
